import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  Alert,
  Row,
  Col,
  Card,
  Container,
  Form,
  Button,
  ButtonGroup,
  Spinner,
  Modal,
  Dropdown,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import CustomNavbar from "../../components/CustomNavbar";
import SidebarDashboard from "../../components/SidebarDashboard";
import CustomPagint from "../../components/CustomPagint";
import { get_tasks, get_tasks_descriptors } from "../../redux/tasks/actions";
const UserMenu = (props) => {
  const filters = [
    { id: "codigo", desc: "Codigo de función" },
    { id: "descripcion", desc: "Descripción función" },
  ];
  //* States
  const [show, setShow] = useState(true);
  // effects
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [func, setFunc] = useState(null);
  const [tipoBusqueda, setTipoBusqueda] = useState({
    id: "codigo",
    desc: "Codigo de función",
  });

  //Redux
  const { tasks, loader, tasksLength } = useSelector((store) => store.tasks);
  const { unidOrg } = useSelector((store) => store.auth);
  // Variables
  const pages = Math.ceil(tasksLength / limit);
  const dispatch = useDispatch();
  const history = useHistory();
  //* Methods
  const getATasks = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      get_tasks_descriptors(
        {
          offset: offs,
          limit: lim,
          filter: filt,
          tipo_busqueda: tipoBusqueda.id,
          unidad_organizativa: unidOrg,
        },
        2
      )
    );
  useEffect(() => {
    getATasks();
  }, []);

  const onSearch = (e) => {
    e.preventDefault();
    if (!e.target.search.value.trim()) {
      return;
    }
    setFilter(e.target.search.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getATasks(oOffset, limit, e.target.search.value);
  };
  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    setCurrentPage(1);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getATasks(oOffset, limit, oSearch);
  };

  const handleFunc = (_func) => {
    setFunc(_func);
    setShowModal(true);
  };
  //const onAdd = () => {}
  const onShowSidebar = () => setShow(show ? false : true);
  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
          <h5 className="text-black-50 m-0 text-uppercase">
            MAN-001 MANUAL DE PUESTOS Y FUNCIONES
          </h5>
          <Form onSubmit={onSearch}>
            <Form.Row className="justify-content-sm-end align-items-center flex-wrap">
              <Col>
                <h6>
                  <b>Búsqueda por: {tipoBusqueda.desc}</b>
                </h6>
              </Col>
              <Col xs="auto">
                <Form.Control
                  name="search"
                  type="search"
                  placeholder="Buscar"
                  className="rounded-pill form-control-sm"
                ></Form.Control>
              </Col>
              <Col xs="auto">
                <ButtonGroup>
                  <Button
                    variant="light"
                    size="sm"
                    className="rounded-pill mr-1"
                    onClick={() => seeAll()}
                  >
                    <i className="material-icons">list</i>
                  </Button>
                  <Dropdown className="ml-1 mr-1">
                    <Dropdown.Toggle
                      variant="light"
                      className="btn-sm font rounded-pill"
                    >
                      <i className="material-icons">filter_list</i>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {filters.map((item) => (
                        <Dropdown.Item
                          onClick={() => setTipoBusqueda(item)}
                          key={item.id}
                        >
                          {item.desc}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                  {/* <Button 
                  variant="light" 
                  size="sm" 
                  className="rounded-pill"
                  onClick={() => onAdd()}><i className="material-icons">add</i></Button> */}
                </ButtonGroup>
              </Col>
            </Form.Row>
          </Form>
        </div>
        <Container fluid>
          <hr />
          {loader ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : tasks.length > 0 ? (
            <div className="mt-4">
              <Row>
                {tasks.map((_func) => (
                  <Col sm="3" className="mb-3">
                    <Button
                      variant="link"
                      className="p-0"
                      style={{ width: "100%" }}
                      onClick={() =>
                        history.push(
                          `/descriptores-perfiles/seleccion-del-descriptor/${
                            _func.id
                          }/${_func.descripcion.replaceAll("/", "-")}`
                        )
                      }
                    >
                      <Card className="bg-aurora">
                        <Card.Body className="text-center font-weight-bold text-white ">
                          <Card.Title>
                            <i
                              className="material-icons"
                              style={{ fontSize: "5.5rem" }}
                            >
                              engineering
                            </i>
                          </Card.Title>
                          {_func.codigo} / {_func.descripcion}
                        </Card.Body>
                      </Card>
                    </Button>
                  </Col>
                ))}
              </Row>
              <div className="mt-4">
                <CustomPagint
                  jContent="justify-content-sm-center"
                  limit={limit}
                  setLimit={setLimit}
                  offset={offset}
                  setOffset={setOffset}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  dataLenght={tasksLength}
                  pages={pages}
                  pagFunc={getATasks}
                />
              </div>
            </div>
          ) : (
            <Alert className="my-4" variant="info">
              No sé encontrarón datos
            </Alert>
          )}
        </Container>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: "1.1rem" }}>
            {func
              ? func.descripcion.length > 37
                ? `${func.descripcion.substring(0, 35)}...`
                : func.descripcion
              : null}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col sm="6" className="mb-3">
              <Link
                // to="#"
                onClick={() =>
                  history.push(
                    `/descriptores-perfiles/seleccion-del-descriptor/${func.id}`
                  )
                }
                style={{ width: "100%" }}
              >
                <Card className="bg-aurora">
                  <Card.Body className="text-center font-weight-bold text-white ">
                    <Card.Title>
                      <i
                        className="material-icons"
                        style={{ fontSize: "5.5rem" }}
                      >
                        card_travel
                      </i>
                    </Card.Title>
                    Descriptor
                  </Card.Body>
                </Card>
              </Link>
            </Col>
            <Col sm="6" className="mb-3">
              <Link to="#" style={{ width: "100%" }}>
                <Card className="bg-aurora">
                  <Card.Body className="text-center font-weight-bold text-white ">
                    <Card.Title>
                      <i
                        className="material-icons"
                        style={{ fontSize: "5.5rem" }}
                      >
                        next_week
                      </i>
                    </Card.Title>
                    Asignar competencias
                  </Card.Body>
                </Card>
              </Link>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default UserMenu;
